import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { animalsRoute } from '~/routes'
import { updateRecord, findRecord, clearState } from '~/store/modules/animals';
import AnimalRecord from '~/records/AnimalRecord';
import CrudEdit from '~/containers/CrudEdit';

import FormFields from './components/FormFields';

export default function Edit() {
  const [record, setRecord] = useState(new AnimalRecord());
  const dispatch = useDispatch();
  const { isLoading, current, errors } = useSelector(state => state.animals);
  const { id } = useParams();

  useEffect(() => {
    dispatch( findRecord(id, {include: 'farm'}) );
    return () => {
      dispatch( clearState() )
    };
  }, [])

  useEffect(() => {
    if(current){
      setRecord( record.updateAttributes(current) )
    }
  }, [current])

  const onSubmit = useCallback( () => {
    const data = record.toParams();
    dispatch( updateRecord(id, data) );
  }, [record, id]);

  const handleChange = useCallback(attrs => {
    setRecord(record.updateAttributes(attrs));
  }, [record, setRecord]);

  return (
    <CrudEdit
      isLoading={isLoading}
      onSubmit={onSubmit}
      errors={{ errors }}
      breadcrumbs={[
        { path: animalsRoute.list.path, text: 'Animais' },
        { text: 'Editando Animal' },
      ]}
      footerActionsProps={{isLoading, showSaveAndContinue: false}}
    >
      <FormFields
        record={record}
        onChange={handleChange}
      />
    </CrudEdit>
  );
}